import axios from "axios";
import { APIS } from "../../../../../utils/api-factory";
const POST_HEADER = {
    // 'Accept': 'application/json',
    "Content-Type": "application/json",
};

export const getAmuScorecard = (callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .get(APIS.GET_AMU_SCORE_CARD, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};

export const saveUpdateAMuScorecard = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .post(APIS.SAVE_UPDATE_AMU_SCORE_CARD, data, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};

export const getRvRetailNumbericPolicyConfig = (id, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .get(APIS.GET_EV_RETAIL_NUMBERIC_POLICY_CONFIG_DO + id, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};

export const getRvRetailTextPolicyConfig = (id, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .get(APIS.GET_EV_RETAIL_TEXT_POLICY_CONFIG_DO + id, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};

export const SaveUpdateEvTextPolicyconfigDo = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .post(APIS.SAVE_UPDATE_EV_RETAIL_TEXT_POLICY_CONFIG_DO, data, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};

export const SaveUpdateEvNumericPolicyconfigDo = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .post(APIS.SAVE_UPDATE_EV_RETAIL_NUMERIC_POLICY_CONFIG_DO, data, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};

export const deleteEvTextPolicyconfigDo = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
        data: data
    };
    axios
        .delete(APIS.DELETE_EV_RETAIL_TEXT_POLICY_CONFIG_DO, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};

export const deleteEvNumericPolicyconfigDo = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
        data: data
    };
    axios
        .delete(APIS.DELETE_EV_RETAIL_NUMERIC_POLICY_CONFIG_DO, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};

export const deleteAmuScorecardcategorycreditParam = (id, callBack, error) => {
    const headerConfig = {
        headers: {},

    };
    axios
        .delete(APIS.DELETE_AMU_SCORE_CARD_CATEGORY_CREDITPARAM + id, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });


};

export const GetEvDealerScorecardDO = (callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .get(APIS.GET_EV_DEALER_SCORE_CARD_DO, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};
export const GetEvOEMScorecardDO = (callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .get(APIS.GET_EV_OEM_SCORE_CARD_DO, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};

export const getNPAWeightageDateByParamId = (Id,callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .get(APIS.GET_NPA_WEIGHTAGE_DATE_BY_PARAMID + Id, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};

export const DeleteNPAWeightageDateByUUId = (uuid,callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .delete(APIS.DELETE_NPA_WEIGHTAGE_BY_ENTRY_BY_UUID + uuid, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};

export const SaveUpdateNpaWeightage = (data,callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .post(APIS.SAVE_UPDATE_NPA_WEIGHTAGE,data, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};

export const UpdateNPaWightageBYUUID = (data,callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .post(APIS.UPDATE_NPA_WEIGHTAGEBY_UUID,data, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};